import { get, ref } from 'firebase/database';
import { SessionWithId } from '../../Models/session';
import { database } from '../firebase';

export const getSession: (
    session: SessionWithId,
) => Promise<SessionWithId | null> = async (session) => {
    let returnSession: SessionWithId | null = null;

    await get(ref(database, `sessions/${session.id}`))
        .then((snapshot) => {
            if (snapshot.exists()) {
                returnSession = {
                    id: session.id,
                    session: snapshot.val(),
                };
            } else {
                throw Error('The session does not exist');
            }
        })
        .catch((err) => {
            throw err;
        });

    return returnSession;
};
